export default "__VITE_ASSET__C6H6Z6mT__"